module.exports = __webpack_public_path__ + "img/首页切片-17.fc43cb80.png";